import React, { useState } from "react";

import { createDirection, fetchDirections } from "@services/directionApi";
import { useAppStore } from "@store/appStateStore";

const AddDirectionForm: React.FC = () => {
  const { setDirections } = useAppStore();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!name.trim()) {
      alert("Пожалуйста, введите название направления");
      return;
    }

    try {
      await createDirection(name, description || undefined);

      const directions = await fetchDirections();
      setDirections(directions);
      setName("");
      setDescription("");
    } catch (error) {
      console.error("Ошибка при добавлении направления:", error);
      alert("Не удалось добавить направление");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <input
          id="directionName"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Название направления"
          required
          className="control"
        />
      </div>
      <div>
        <input
          id="directionDescription"
          type="text"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Описание (необязательно)"
          className="control"
        />
      </div>
      <button type="submit" className="control">
        Добавить направление
      </button>
    </form>
  );
};

export default AddDirectionForm;
